module.exports = __webpack_public_path__ + "static/media/react-logo.80687d23.png";